import { FC } from 'react';
import './ToolInfoTabSkeleton.scss';

const ToolInfoTabSkeleton: FC = () => {
  return (
    <div className="toolInfoTabSkeleton">
      <div className="skeletonAlert skeletonLine" />

      <div className="skeletonConditions">
        <div className="skeletonMessage skeletonLine" />
        {Array?.from({ length: 8 })?.map((_, index) => (
          <div key={index} className={`skeletonConditionItem ${index === 0 ? 'border-t mt-12' : ''}`}>
            <div className="skeletonLine skeletonLineHalf" />
            <div className="skeletonSwitch" />
          </div>
        ))}
        <div className="skeletonConditionItem">
          <div className="skeletonLine skeletonLineHalf" />
          <div className="skeletonDropdown" />
        </div>
      </div>

      <div className="skeletonEvidence">
        <div className="skeletonEvidenceTitle">
          <div className="skeletonLine skeletonLineHalf" />
        </div>
        <div className="skeletonEvidenceItems">
          {Array?.from({ length: 5 })?.map((_, index) => (
            <div key={index} className="skeletonEvidenceItem" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ToolInfoTabSkeleton;

